import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi, createBaseFilesApi } from '@/api/base'

export const APPROVE_URL = 'approve'

const errors = createBaseResponseErrors('лист согласования', 'листы согласования')

export const ApproveApi = {
  ...createBaseCRUDApi(APPROVE_URL, errors),
  ...createBaseFilesApi(APPROVE_URL)
}
